// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tickets-table{opacity:0;-webkit-transform:scale(0);transform:scale(0)}", ""]);
// Exports
module.exports = exports;
